import React from 'react';

type KPISectionProps = {
  firstTitle: string;
  secondTitle: string;
  firstKpiLabel: string;
  secondKpiLabel: string;
  firstKpi: number;
  secondKpi: number;
};

export const KPIDoubleSection: React.FC<KPISectionProps> = ({ firstTitle, secondTitle, firstKpiLabel, secondKpi, secondKpiLabel, firstKpi }) => (
  <>
    <div className="grid grid-cols-2 gap-2 mt-2">
      <div className="flex gap-2 flex-col bg-shades-primary-active rounded-xl text-center p-4">
        <p className="text-white font-bold text-md">{firstTitle}</p>
        <div className="flex w-full items-center text-center justify-center">
          <span>
            <dd className="text-4xl font-semibold tracking-tight text-white ">{firstKpi}</dd>
            <dd className="mt-1 text-md font-semibold tracking-tight text-white ">{firstKpiLabel}</dd>
          </span>
        </div>
      </div>

      <div className="flex gap-2 flex-col bg-shades-primary-active rounded-xl text-center p-4">
        <p className="text-white font-bold text-md">{secondTitle}</p>
        <div className="w-full items-center text-center">
          <span>
            <dd className="text-4xl font-semibold tracking-tight text-white ">{secondKpi}</dd>
            <dd className="mt-1 text-md font-semibold tracking-tight text-white ">{secondKpiLabel}</dd>
          </span>
        </div>
      </div>
    </div>
  </>
);
